import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LANGUAGES } from 'src/app/constants';
import { AuthService } from '../../services/auth.service';
import { FormTypeBuilder } from '@shared/models/formTypeBuilder';
import { LoginFormType } from './login.component.types';
import { UserLoginDTO } from '../../models';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup<FormTypeBuilder<LoginFormType>>;
  public languageSelect = LANGUAGES;

  constructor(
    private fb: FormBuilder,
    private translateService: TranslateService,
    private auth: AuthService
  ) {
    this.loginForm = this.fb.group<FormTypeBuilder<LoginFormType>>({
      Email: new FormControl(null, [Validators.required, Validators.email]),
      Password: new FormControl(null, [Validators.required]),
      Recaptcha: new FormControl<string | null>(null, Validators.required),
      Language: new FormControl<string>(this.languageSelect[0]),
    });

    this.loginForm.get('Language')?.valueChanges.subscribe((lang) => {
      if (lang) {
        this.translateService.use(lang.toLowerCase());
      }
    });
  }

  submit() {
    const { Recaptcha, Language, ...data } = this.loginForm.value;
    if (data.Email && data.Password && this.loginForm.valid) {
      const payload: UserLoginDTO = {
        Email: data.Email,
        Password: data.Password,
      };
      this.auth.login(payload).subscribe();
    }
  }

  ngOnInit(): void {}
}
